import { Link } from "react-router-dom";
import { useReveal } from "../hooks/useReveal";

const APPLICAZIONI = ["Terrazzi panoramici", "Balconi", "Dehor e locali commerciali", "Verande e spazi outdoor"];
const SOLUZIONI = [
  "Vetrate panoramiche per terrazzi",
  "Chiusura balconi in vetro",
  "Sistemi scorrevoli in vetro",
  "Vetrate per dehor e locali commerciali",
];

export const HomeIntro = () => {
  const [ref, inView] = useReveal();
  return (
    <section data-testid="home-intro" className="py-24 md:py-32 px-6 md:px-12 bg-[#FAFAFA]">
      <div ref={ref} className={`max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 reveal ${inView ? "in-view" : ""}`}>
        <div className="text-center lg:text-left">
          <p className="text-xs uppercase tracking-[0.35em] text-champagne mb-5">VETRO DESIGN ITALIA</p>
          <h2 className="font-serif font-light text-3xl sm:text-4xl tracking-tight leading-tight mb-8">
            Vetrate panoramiche VEPA e soluzioni in vetro indoor &amp; outdoor.
          </h2>
          <div className="space-y-4 text-foreground/75 font-light leading-relaxed">
            <p>VETRO DESIGN ITALIA progetta e installa sistemi di vetrate panoramiche VEPA e soluzioni in vetro indoor &amp; outdoor.</p>
            <p>Con sede ad <strong className="font-medium text-foreground">Osimo</strong>, operiamo prevalentemente nelle <strong className="font-medium text-foreground">Marche</strong> e realizziamo interventi su tutto il territorio nazionale. Ogni progetto viene sviluppato su misura per abitazioni private, attività commerciali e strutture ricettive.</p>
          </div>

          <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground mt-10 mb-4">Applicazioni</p>
          <div className="flex flex-wrap gap-2 justify-center lg:justify-start">
            {APPLICAZIONI.map((a) => (
              <span key={a} className="text-sm font-light border border-black/15 px-4 py-2">{a}</span>
            ))}
          </div>
        </div>

        <div className="lg:border-l lg:border-black/10 lg:pl-16 text-center lg:text-left">
          <h3 className="font-serif text-2xl font-light mb-5">Vetrate panoramiche VEPA</h3>
          <div className="space-y-4 text-foreground/75 font-light leading-relaxed">
            <p>Le vetrate panoramiche VEPA sono sistemi in vetro senza profili verticali, progettati per chiudere e valorizzare spazi esterni come terrazzi, balconi e dehor.</p>
            <p>In molti casi, in funzione delle caratteristiche dell'intervento e della normativa vigente, possono rientrare tra le installazioni di edilizia libera.</p>
          </div>

          <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground mt-10 mb-4">Soluzioni</p>
          <ul className="space-y-3">
            {SOLUZIONI.map((s) => (
              <li key={s}>
                <Link
                  to="/vetrate-panoramiche-vepa"
                  onClick={() => window.scrollTo({ top: 0 })}
                  className="group inline-flex items-center gap-2 text-foreground/80 font-light hover:text-foreground transition-colors"
                >
                  <span className="w-4 h-px bg-champagne group-hover:w-7 transition-all duration-300" />
                  {s}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
